module.exports = __webpack_public_path__ + "img/logo_fotor.a815bf9.png";